
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, VendorContactViewModel, VendorUserContext } from "@tylertech/tyler-api-types";

/**
 * VendorContactService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class VendorContactService {
    private readonly $apiService = inject(ApiService);
    
    AddUser(pVendorUser: VendorUserContext): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IVendorContactService/AddUser", pVendorUser);
    }
    Delete(pId: string): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IVendorContactService/Delete", pId);
    }
    Get(pId: string): Promise<ExecutionResult<VendorContactViewModel>> {
        return this.$apiService.sendAuth("IVendorContactService/Get", pId);
    }
    GetTypes(): Promise<ExecutionResult<string[]>> {
        return this.$apiService.sendAuth("IVendorContactService/GetTypes");
    }
    Save(pContact: VendorContactViewModel): Promise<ExecutionResult<VendorContactViewModel>> {
        return this.$apiService.sendAuth("IVendorContactService/Save", pContact);
    }
}
